import { createAction, props } from '@ngrx/store';
import { PigFunctions } from '../pig.models';

export const updatePigFunctions = createAction('[Pig] Update pig functions', props<{ functions: PigFunctions }>());
export const loadPigFunctions = createAction('[Pig] Load pig functions');
export const loadPigFunctionsError = createAction('[Pig] Load pig functions error');
